/* ===========================================================
   Gold Coast theme — cart, overlays, motion
   Uses Shopify's AJAX Cart API (no localStorage).
   =========================================================== */
(function () {
  'use strict';

  var R = (window.GCC && window.GCC.routes) || {};
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = (window.GCC && window.GCC.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* ---------- overlays ---------- */
  function shut() {
    $$('.drawer,.mnav,.search,.filters,.modal').forEach(function (el) { el.classList.remove('is-on'); });
    var s = $('#scrim'); if (s) s.classList.remove('is-on');
    document.body.style.overflow = '';
  }
  function open(sel) {
    var el = $(sel); if (!el) return;
    el.classList.add('is-on');
    var s = $('#scrim'); if (s) s.classList.add('is-on');
    document.body.style.overflow = 'hidden';
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      e.preventDefault(); open(o.dataset.open);
      if (o.dataset.open === '#search') setTimeout(function () { var f = $('#searchInput'); if (f) f.focus(); }, 260);
      return;
    }
    if (e.target.closest('[data-close]') || e.target.id === 'scrim') shut();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });

  var tTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.innerHTML = '<i></i>' + msg;
    t.classList.add('is-on');
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* ---------- cart ---------- */
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function lineHTML(item, i) {
    var img = item.image
      ? '<img src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" width="78" height="92">'
      : '';
    var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
      ? '<div class="opt">' + esc(item.variant_title) + '</div>' : '';
    return '<div class="cline" data-line="' + (i + 1) + '">' + img +
      '<div><b>' + esc(item.product_title) + '</b>' + variant +
      '<div class="opt">' + money(item.final_price) + '</div>' +
      '<div class="row"><div class="qty">' +
      '<button type="button" data-qty="' + (i + 1) + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
      '<span>' + item.quantity + '</span>' +
      '<button type="button" data-qty="' + (i + 1) + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
      '</div><button class="rm" type="button" data-qty="' + (i + 1) + '" data-to="0">Remove</button>' +
      '</div></div></div>';
  }

  function refreshCart() {
    return fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.js-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count ? 'grid' : 'none';
        });
        var tot = $('[data-cart-total]'); if (tot) tot.textContent = money(cart.total_price);
        var foot = $('#cartFoot'); if (foot) foot.style.display = cart.item_count ? 'grid' : 'none';

        var body = $('[data-cart-body]');
        if (body) {
          body.innerHTML = cart.items.length
            ? cart.items.map(lineHTML).join('')
            : '<div class="empty"><b>Your bag is empty</b><p>Nothing in here yet.</p></div>';
        }
        return cart;
      });
  }

  function addToCart(id, qty) {
    return fetch(R.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); });
      return r.json();
    }).then(function () {
      toast('Added to bag');
      return refreshCart();
    }).then(function () {
      if (window.GCC.cartDrawer) open('#cartDrawer');
    }).catch(function (err) { toast(err.message); });
  }

  function changeLine(line, qty) {
    return fetch(R.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(function () { return refreshCart(); })
      .catch(function () { location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (q) { e.preventDefault(); e.stopPropagation(); addToCart(q.dataset.quickAdd, 1); return; }

    var ch = e.target.closest('[data-qty]');
    if (ch) { e.preventDefault(); changeLine(ch.dataset.qty, ch.dataset.to); return; }

    var ct = e.target.closest('[data-cart-toggle]');
    if (ct && window.GCC.cartDrawer) { e.preventDefault(); open('#cartDrawer'); }
  });

  /* product form */
  var form = $('#productForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sel = $('#variantSelect');
      var btn = $('[data-add-btn]');
      if (btn) btn.disabled = true;
      addToCart(sel.value, 1).then(function () { if (btn) btn.disabled = false; });
    });
  }

  /* variant option picker */
  var variants = (function () {
    var el = $('#variantData');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  })();
  if (variants.length) {
    var chosen = {};
    $$('[data-opt].is-on').forEach(function (b) { chosen[b.dataset.opt] = b.dataset.val; });
    $$('[data-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        chosen[b.dataset.opt] = b.dataset.val;
        $$('[data-opt="' + b.dataset.opt + '"]').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        var lbl = $('[data-opt-label="' + b.dataset.opt + '"]');
        if (lbl) lbl.textContent = b.dataset.val;

        var want = Object.keys(chosen).sort().map(function (k) { return chosen[k]; });
        var match = variants.filter(function (v) {
          return want.every(function (val, i) { return v['option' + (i + 1)] === val; });
        })[0];
        if (!match) return;
        $('#variantSelect').value = match.id;
        var price = $('[data-price]');
        if (price) price.textContent = money(match.price);
        var btn = $('[data-add-btn]');
        if (btn) {
          btn.disabled = !match.available;
          btn.textContent = match.available ? 'Add to bag' : 'Sold out';
        }
        if (match.featured_image) {
          var main = $('#galMain');
          if (main) main.src = match.featured_image.src;
        }
      });
    });
  }

  /* gallery thumbs */
  $$('[data-shot]').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = $('#galMain'); if (main) main.src = b.dataset.shot;
      $$('[data-shot]').forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on');
    });
  });

  /* collection sort */
  var sortForm = $('#sortForm');
  if (sortForm) {
    sortForm.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sortForm.querySelector('select').value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
  }

  /* ---------- motion ---------- */
  var io;
  function observe() {
    var els = $$('.rv:not(.in), .clip:not(.in), .stagger:not(.in)');
    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); }); return;
    }
    if (!io) {
      io = new IntersectionObserver(function (list) {
        list.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .05 });
    }
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(function (e) { e.classList.add('in'); }); }, 3000);
  }

  var pars = [], ticking = false;
  function parallax() {
    if (REDUCED || !pars.length || ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      pars.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var sp = parseFloat(el.dataset.speed || '.12');
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-mid * sp).toFixed(2) + 'px,0) scale(1.12)';
      });
      ticking = false;
    });
  }

  function railBars() {
    $$('.rail-wrap').forEach(function (w) {
      var rail = $('.rail', w), bar = $('.rail-bar i', w);
      if (!rail || !bar || rail.dataset.bound) return;
      rail.dataset.bound = '1';
      var upd = function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var pct = max > 0 ? rail.scrollLeft / max : 0;
        var w2 = Math.max(12, (rail.clientWidth / rail.scrollWidth) * 100);
        bar.style.width = w2 + '%';
        bar.style.transform = 'translateX(' + (pct * (100 / w2 * 100 - 100)) + '%)';
      };
      rail.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  function boot() {
    pars = $$('.par');
    observe(); railBars(); parallax();
    window.addEventListener('scroll', parallax, { passive: true });
    var h = $('.hero__copy'); if (h) requestAnimationFrame(function () { h.classList.add('is-lit'); });
  }

  document.addEventListener('DOMContentLoaded', boot);

  function dropCurtain() {
    var c = $('#curtain');
    if (c) setTimeout(function () { c.classList.add('gone'); }, REDUCED ? 0 : 200);
  }
  if (document.readyState === 'complete') dropCurtain();
  else window.addEventListener('load', dropCurtain);
  setTimeout(dropCurtain, 2000);

  /* theme editor support — re-init when sections are re-rendered */
  document.addEventListener('shopify:section:load', function () { boot(); });
  document.addEventListener('shopify:section:select', function () { boot(); });
})();
